import { Component, Input, ViewChild, ElementRef, Output, EventEmitter, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LookupItem, TemplateAssignment } from '@/shared/models/shared';
import { MessageService, SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from '@/core/services/data.service';
import { toDate } from '@/shared/classes/utils';

@Component({
    selector: 'ciee-template-assignment-edit',
    templateUrl: './template-assignment-edit.component.html',
    styleUrls: ['./template-assignment-edit.component.scss'],
    standalone: false
})
export class TemplateAssignmentEditComponent implements OnInit {
  @ViewChild('form', { static: false }) form: NgForm;
  @ViewChild('messages', { static: false }) messagesElement: ElementRef;

  @Input() record: TemplateAssignment;
  @Input() visible: boolean = false;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() recordSaved: EventEmitter<TemplateAssignment> = new EventEmitter<TemplateAssignment>();
  
  errors: Array<any> = [];
  model: TemplateAssignment = new TemplateAssignment();

  versionNumber: string;
  allVersions: Array<SelectItem>;

  showIsApproved: boolean;

  constructor(private http: DataService, private messenger: MessageService) {

  }

  ngOnInit() {
    this.model = this.record;
    this.showIsApproved = !this.model.isApproved;

    if (this.model.sectionTemplateId) {
      this.versionNumber = this.model.sectionTemplateId.toString();
    }

    this.model.taskDeadlineDate = toDate(this.model.taskDeadlineDate)

    this.getLookups();
  }

  getLookups() {
    this.getLookup(`sectionTemplateInstanceSets/${this.model.sectionTemplateInstanceSetId}/versions`).subscribe(res => {
      this.allVersions = res.filter(x => x.value).sort((a, b) => parseInt(a.label) - parseInt(b.label));
    }        , res => this.reportError(res));
  }

  getLookup(lookupType: string, excluded?: Array<SelectItem>): Observable<LookupItem[]> {
    return this.http.get(`/template/lookup/${lookupType}`).pipe(map((resp: Array<any>) => {
      resp.sort((a, b) => (a.label > b.label) ? 1 : -1);
      if (!excluded) {
        return resp;
      }

      return resp.filter(x => excluded.filter(y => y.value == x.value).length == 0);
    }));
  }

  close() {
    this.visible = false;
  }
  
  onClose() {
    this.visibleChange.emit(this.visible);
    this.form.resetForm(this.form.value);
  }

  onVersionChange() {
    this.model.sectionTemplateId = parseInt(this.versionNumber);
    this.model.sectionTemplateVersion = parseInt(this.allVersions.filter(x => x.value == this.versionNumber)[0].label);
    this.onFormChange();
  }

  onFormChange() {
    this.form.form.markAsDirty();
  }

  isFormInvalid() {
    return !this.form
      || !this.form.form.valid
      || this.form.form.pristine;
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }

    this.errors = [];
    this.visible = false;
    this.recordSaved.emit(this.model);
  }

  reportError(response) {
    console.log(response);
    if (response.status == 400) {
      response.error.forEach(err => this.messenger.add({ severity: 'error', summary: 'Error', detail: err }));
    }
  }
}
